import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import PinPage from '../../../components/PinPage/PinPage';
import { toastNotify } from '../../../utils/toastNotify';

const CreatePin = () => {
  const [pin, setPin] = useState(undefined);
  let navigate = useNavigate();
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');
  useEffect(() => {
    if (token) {
      localStorage.setItem('access_token_temp', token);
      window.history.replaceState(null, window.location.pathname, window.location.pathname);
    } else if (!token && !localStorage.getItem('access_token_temp')) {
      navigate('/login', { replace: true });
    }
  }, []);
  const handleCreatePin = () => {
    if (!pin || pin.length < 4) {
      toastNotify('error', 'please fill all the fields');
    } else {
      localStorage.setItem('pin', pin);
      window.location.pathname.includes('reactive-account/createpin') ? navigate('/reactive-account/confirmpin') : navigate('/sign-up/confirmpin');
    }
  };

  return (
    <div className='auth auth--no-info-mobile'>
      <PinPage
        pin={pin}
        authInfoTitle={'Create a PIN to secure your account'}
        authInfoDescription={'Do not share your 4-digit PIN with anyone under any circumstances.'}
        authFormTitle={'Create a new 4-digit PIN'}
        authFormDescription={'This PIN will be use as a security measure to prevent unathorized access to your account and for you to easily log in.'}
        lockMessage={'All of your information is encrypted and secure.'}
        setPin={(value) => setPin(value)}
        loading={false}
        buttonName={'Save PIN'}
        handleSubmit={handleCreatePin}
      />
    </div>
  );
};

export default CreatePin;
